import React, { createContext, useMemo, useContext, useEffect, useState } from 'react';
import { HttpClient } from '../lib/http/HttpClient';
import { AuthClient } from '../lib/auth/AuthClient';
import { ApiClient } from '../lib/api/ApiClient';
import { MemoryTokenStore } from '../lib/auth/TokenStore';

export const SecurityContext = createContext({ 
  auth: null, 
  api: null,
});

export function SecurityProvider({ children, apiBaseURL, authBasePath = '/auth', apiBasePath = '/api' }) {
   //const [user, setUser] = useState(null);
   const [loading, setLoading] = useState(true);

  const value = useMemo(() => {
    const tokenStore = new MemoryTokenStore(); // access token en memoria

    const http = new HttpClient({
      baseURL: apiBaseURL,
      credentials: 'include', // para enviar cookie refresh_token en /auth/refresh
      getAccessToken: () => tokenStore.get()?.accessToken,
    });

    const auth = new AuthClient({ http, tokenStore, basePath: authBasePath });
    const api = new ApiClient({ http, tokenStore, auth, basePath: apiBasePath });
    return { auth, api };
  }, [apiBaseURL, authBasePath, apiBasePath]);


  useEffect(() => {
    const initAuth = async () => {
      try {
        setLoading(true);

        // 1. Intentamos refrescar el token (usa la cookie del navegador)
        await value.auth.refresh();
        
        // 2. Si funcionó, pedimos los datos del usuario
        //const userData = await value.auth.me();
        //setUser(userData);
        
      } catch (error) {
        // Si falla (token expirado o no existe), no hacemos nada, el usuario queda anónimo
        console.log("Sesión no recuperada, usuario anónimo");
        //setUser(null);

      } finally {
        // 3. Ya terminamos de verificar, podemos mostrar la app
        setLoading(false);
      }
    };

    initAuth();
  }, [value.auth]); // Se ejecuta al montar

  return (
    <SecurityContext.Provider value={value}>
      {children}
    </SecurityContext.Provider>
  );
}


/**
 * Hook personalizado para acceder a 'auth' y 'api' rápidamente.
 */
export const useSecurity = () => {
  const context = useContext(SecurityContext);
  
  if (!context) {
    throw new Error('useSecurity debe ser usado dentro de un SecurityProvider');
  }
  
  return context; 
};